<div class="centered-content">
  <div class="text-center loading-outer">
    <div class="loading"></div>
  </div>
</div>